import { Controller } from "@hotwired/stimulus";

const SYMBOL_MAP = {
  GBP: "£",
  USD: "$",
  EUR: "€",
};

const selectedValue = (selectEl) => selectEl[selectEl.selectedIndex].value;

// Connects to data-controller="contribution-form"
export default class extends Controller {
  static targets = [
    "currency",
    "button",
    "monthly",
    "monthlyFieldset",
    "annualFieldset",
  ];
  static outlets = ["amount-selector"];

  connect() {
    this.localize();
    this.updateButtonText();
  }

  localize() {
    const symbol = this.currencySymbol;

    for (const amountSelector of this.amountSelectorOutlets) {
      amountSelector.currencySymbol = symbol;
    }
  }

  toggleInterval() {
    const monthly = this.monthlyTarget.checked;

    this.monthlyFieldsetTarget.disabled = !monthly;
    this.monthlyFieldsetTarget.hidden = !monthly;

    this.annualFieldsetTarget.disabled = monthly;
    this.annualFieldsetTarget.hidden = monthly;
  }

  updateButtonText() {
    for (const amountSelector of this.amountSelectorOutlets) {
      if (amountSelector.active && amountSelector.value) {
        const interval = this.monthlyTarget.checked ? "month" : "year";

        this.buttonTarget.value = `Contribute ${this.currencySymbol}${amountSelector.value} a ${interval}`;
        return;
      }
    }
  }

  disambiguateAmount() {
    for (const amountSelector of this.amountSelectorOutlets) {
      amountSelector.disambiguate();
    }
  }

  get currencySymbol() {
    const currentCurrency = selectedValue(this.currencyTarget).toUpperCase();
    return SYMBOL_MAP[currentCurrency];
  }
}
